// apps/admin/src/features/notifications/wsVersionFloor.ts
//
// Phase 15 (Notification & Email Consolidation) — Task 25
// VERSION-FLOOR bundle marker (P15.D-18). This constant is the grep-verifiable
// artifact Task 29 (Wave 8, server-side legacy-emitter removal) waits on: it
// stamps THIS bundle as one that speaks the canonical `notification.new` event
// (signal-only WS, see canonical publisher apps/api/.../ws/publisher.ts).
//
// How the floor is enforced without a BE round-trip: the WS notification signal
// frame MAY carry a server-advertised `minClientVersion`. Every client from
// Task 25 onward checks its baked `NOTIFICATION_WS_CONTRACT_VERSION` against that
// floor; when the running bundle is below it, the client is stale → prompt the
// user to reload. Once Task 25 is rolled out (this marker present in every
// deployed SPA), Task 29 can bump the emitted floor and any surviving old tab is
// forced to reload before the legacy `notification.create` emitter is removed.
//
// vg-binding: CONTEXT:decisions
// vg-binding: INTERFACE-STANDARDS:error-shape

/**
 * Contract version this bundle speaks. `2` = the `notification.new` era
 * (P15.D-18); `1` was the legacy `notification.create`-only era. Bump when the
 * WS notification contract changes again.
 */
export const NOTIFICATION_WS_CONTRACT_VERSION = 2 as const;

/**
 * Highest floor we have already surfaced a reload prompt for — so a burst of
 * signal frames (dual-emit: `notification.new` + legacy `notification.create`)
 * never re-prompts for the same floor.
 */
let highestPromptedFloor = 0;

/**
 * Returns true exactly once per newly-observed floor when the server advertises
 * a `minClientVersion` greater than this bundle's baked contract version — i.e.
 * this client is below the version-floor and must reload. Signal frames without
 * a numeric `minClientVersion` (today's dual-emit window) always return false.
 */
export function isNotificationBundleStale(payload: unknown): boolean {
  const raw = (payload as { minClientVersion?: unknown } | null | undefined)
    ?.minClientVersion;
  const floor = typeof raw === 'number' ? raw : Number.NaN;
  if (!Number.isFinite(floor)) return false;
  if (floor <= NOTIFICATION_WS_CONTRACT_VERSION) return false;
  if (floor <= highestPromptedFloor) return false;
  highestPromptedFloor = floor;
  return true;
}
